import { createContext } from 'react';
import type { ToastContextInterface } from './ToastContextProvider';

// create context

export const ToastContext = createContext<ToastContextInterface>(
  {} as ToastContextInterface,
);
